import type { HubNotification, WaitingRequest } from '../api/notifications';
import { productInfo } from './productInfo';
import type { NotificationsState } from './notificationsStore';

export const PANEL_WAITING_LIMIT = 5;
export const POLL_INTERVAL_MS = 60_000;

const WRITE_PERMISSION = 'org-admin:user-write';

export function canSeeWaiting(permissions: readonly string[] | null | undefined): boolean {
  return (permissions ?? []).includes(WRITE_PERMISSION);
}

export function unreadCount(state: NotificationsState | null): number {
  if (!state) return 0;
  return state.waiting.length + state.updates.filter((u) => !u.readAt).length;
}

const who = (w: WaitingRequest) => w.requesterName ?? 'Someone';
const product = (id: string) => productInfo(id).productName;

export function waitingLine(w: WaitingRequest): string {
  return `${who(w)} asked for access to ${product(w.productId)}`;
}

export function overflowLine(hidden: number): string {
  return `and ${hidden} more access request${hidden === 1 ? '' : 's'}`;
}

export function updateLine(u: HubNotification): string {
  return u.kind === 'access_dismissed'
    ? `Your request for ${product(u.productId)} wasn't approved`
    : `You now have access to ${product(u.productId)}`;
}

export function bannerHeadline(count: number): string {
  return count === 1 ? '1 person is waiting for access' : `${count} people are waiting for access`;
}

export function bannerDetail(waiting: WaitingRequest[]): string {
  const named = waiting.slice(0, 2);
  const parts = named.map((w, i) => (i === 0 ? `${who(w)} asked for ${product(w.productId)}` : `${who(w)} for ${product(w.productId)}`));
  const rest = waiting.length - named.length;
  if (rest > 0) parts.push(`and ${rest} other${rest === 1 ? '' : 's'}`);
  return parts.join(', ');
}
